import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Lesson } from "../common/api";
import { Account } from "../common/context/AccountContext";
import { LeftCornerDecoration, LessonItemBody } from "./LessonItemBody";
import {
  AnalyticsContext,
  LessonCellTapEvent,
  SuggestedLessonCellTapEvent,
  MyClassLessonCellTapEvent,
  StudentAssignedLessonCellTapEvent,
} from "../common/context/AnalyticsContext";

export enum LessonItemLoggingContext {
  None,
  Lesson,
  MyClass,
  Suggested,
  StudentAssigned,
  Practice,
}
export const LessonItem = ({
  unitId,
  lesson,
  account,
  leftCornerDecoration,
  isCompact = false,
  loggingContext = LessonItemLoggingContext.None,
}: {
  unitId: number | null;
  lesson: Lesson;
  account: Account;
  leftCornerDecoration: LeftCornerDecoration;
  isCompact?: boolean;
  loggingContext: LessonItemLoggingContext;
}) => {
  const history = useHistory();
  const { logEvent } = React.useContext(AnalyticsContext);

  return (
    <Link
      to={
        lesson.custom_flashpack_id
          ? `/lessons/${lesson.id}/${lesson.slug}/flashpacks/${lesson.custom_flashpack_id}/`
          : `/lessons/${lesson.id}/${lesson.slug}/`
      }
      onClick={(event) => {
        switch (loggingContext) {
          case LessonItemLoggingContext.Lesson:
            logEvent(new LessonCellTapEvent(lesson.id, lesson.title));
            break;
          case LessonItemLoggingContext.Suggested:
            logEvent(new SuggestedLessonCellTapEvent(lesson.id, lesson.title));
            break;
          case LessonItemLoggingContext.MyClass:
            logEvent(new MyClassLessonCellTapEvent(lesson.id, lesson.title));
            break;
          case LessonItemLoggingContext.StudentAssigned:
            logEvent(
              new StudentAssignedLessonCellTapEvent(lesson.id, lesson.title)
            );
            break;
          case LessonItemLoggingContext.None:
            break;
        }
        history.push(
          lesson.custom_flashpack_id
            ? `/lessons/${lesson.id}/${lesson.slug}/flashpacks/${lesson.custom_flashpack_id}/`
            : `/lessons/${lesson.id}/${lesson.slug}/`,
          { unitId: unitId }
        );
        event.preventDefault();
      }}
      style={{ textDecoration: "none" }}
    >
      <LessonItemBody
        lesson={lesson}
        account={account}
        isCompact={isCompact}
        leftCornerDecoration={leftCornerDecoration}
      />
    </Link>
  );
};
